import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { CloudflareStreamModule } from '@cloudflare/stream-angular';
import { Video } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { CheckboxComponent } from '@lyceo/shared/ui-forms';

@Component({
  selector: 'lyceo-paragraph-video',
  imports: [CloudflareStreamModule, CheckboxComponent],
  templateUrl: './paragraph-video.component.html',
  styleUrls: ['./paragraph-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParagraphVideoComponent {
  public readonly video: InputSignal<Video> = input.required<Video>();
  public readonly watched: InputSignal<boolean> = input.required<boolean>();
  public readonly hasWatched: OutputEmitterRef<Video> = output<Video>();
  public readonly playClicked: OutputEmitterRef<Video> = output<Video>();

  private played: boolean = false;

  public play(): void {
    if (!this.played) {
      this.playClicked.emit(this.video());
      this.played = true;
    }
  }

  public setHasWatched(): void {
    this.hasWatched.emit(this.video());
  }

  public videoTimeUpdate(event: Event): void {
    if (this.watched()) {
      return;
    }

    const video: HTMLMediaElement = event.target as HTMLMediaElement;
    if (video.duration === 0) {
      return;
    }

    const percentageWatched: number =
      (video.currentTime / video.duration) * 100;
    const moreThanFiveSecondsRemaining: boolean =
      video.duration - video.currentTime > 5;
    if (
      percentageWatched < 95 ||
      (percentageWatched >= 95 && moreThanFiveSecondsRemaining)
    ) {
      return;
    }

    this.setHasWatched();
  }
}
